"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isProductionEnv = exports.environmentName = exports.environmentType = exports.projectId = void 0;
exports.projectId = process.env["REACT_APP_FIRE_BASE_PROJECT_ID"];
exports.environmentType = {
    "roi-tatemono-shop-enquete-dev": "dev",
    "fancrew-in-shop": "production",
    unknown: "unknown",
}[exports.projectId || "unknown"] || exports.projectId;
exports.environmentName = {
    "roi-tatemono-shop-enquete-dev": "開発",
    "fancrew-in-shop": "本番",
    unknown: "未指定",
}[exports.projectId || "unknown"] || exports.projectId;
exports.isProductionEnv = exports.projectId === "fancrew-in-shop";
